import { Divider, Stack } from "@mui/material";
import { LoginDriver } from "./LoginDriver";
import { NewPracticeForm } from "./NewPracticeForm";
import { NewSenderForm } from "./NewSenderForm";
import { SenderAndRecipientInfo } from "./SenderAndRecipientInfo";

export const InfoDriver = ({
  originator,
  recipient,
  control,
  watch,
  loading,
  setLoading,
  setError,
  setFormError,
  clearErrors,
  reloadAuthData,
  hanldeLogout,
  loginState,
  setLoginState,
  setValue,
  setProviders,
}) => {
  return !originator ? (
    <Stack justifyContent={"flex-start"} gap={0}>
      <div className="h-fit text-left">
        <LoginDriver
          originator={originator}
          loading={loading}
          setError={setError}
          setLoading={setLoading}
          reloadAuthData={reloadAuthData}
          state={loginState}
          setState={setLoginState}
          hanldeLogout={hanldeLogout}
          flex={1}
        />
      </div>
      <div className="my-2 text-left">
        Your Practice Information
        <Divider />
      </div>
      <NewPracticeForm
        control={control}
        loading={loading}
        originator={originator}
        watch={watch}
        setError={setError}
        setValue={setValue}
        setProviders={setProviders}
      />
      <div className="my-2 text-left">
        Sender Information
        <Divider />
      </div>
      <NewSenderForm
        control={control}
        watch={watch}
        loading={loading}
        originator={originator}
        setValue={setValue}
        setError={setError}
        setFormError={setFormError}
        clearErrors={clearErrors}
      />
    </Stack>
  ) : (
    <SenderAndRecipientInfo originator={originator} recipient={recipient} />
  );
};
